export enum ScriptCategory {
  Unknown = '',
  StrictlyNecessary = 'C1',
  Performance = 'C2',
  Functional = 'C3',
  Targeting = 'C4',
  SocialMedia = 'C5',
  Miscellaneous = 'C8',
  Analytics = 'C9',
}
